// export let baseUrl = 'https://punegrocers.com/api/'
//export let baseUrl = "https://puneeats.com/api/";
// export let baseUrl = 'https://vegaschow.com/api/'
// export let baseUrl = '/test/'
//  export let baseUrl = '/live/'
export let baseUrl = "https://live.nirvanaxp.com:443/";
export let imageUrl = "https://images.nirvanaxp.com:443/";


// export let baseUrl = 'https://z12.nirvanaxp.com:443/'
// export let baseUrl = "https://test.nirvanaxp.com:443/";
// export let baseUrl = 'https://uat.nirvanaxp.com:443/'

export const appServerResources = {
  propertyId: 1, //las vegas
  // propertyId: 2, // pune
  shouldDisableBackButton : 0,

  //  propertyId : 3, //pune grocers
  androidVersion: 9,
  iosVersion: 3,
  SERVER_PATH: baseUrl,
  VERSION: "V6",
  IsDunzoInTestMode: 0, //0 for Live and 1 for testing
  VERIFICATION_URL:
    baseUrl + "customer_app/index.php/change_password/?auth_code=",
  IMAGE_PATH:
  imageUrl +
    "images/location_images/120_120/",
  LOCATION_IMAGE_PATH:
  imageUrl +
    "images/location_images/120_120/",
  LOCATIONTOIMAGE_PATH:
  imageUrl + "images/location_images/",
  ITEM_CHAR_IMAGE_PATH:
  imageUrl +
    "images/menu_images/ItemChar/64_64/",
  ITEM_IMAGE_100_100_PATH:
  imageUrl +
    "images/menu_images/Item/100_100/",
  ITEM_IMAGE_400_400_PATH:
  imageUrl +
    "images/menu_images/Item/400_400/",
  ITEM_IMAGE_850_550_PATH:
  imageUrl +
    "images/menu_images/Item/850_550/",
  ITEM_IMAGE_650_650_PATH:
  imageUrl +
    "images/menu_images/Item/650_650/",
  ORDER_STATUS_IMAGE:
  imageUrl + "images/Order status/",
  CATEGORY_IMAGE_PATH : 
  imageUrl + "images/menu_images/Category/100_100/",
  ORDER_TRACK_IMAGE_PATH : 
  imageUrl + "images/menu_images/Category/",
  LOCATION_TO_IMAGES:imageUrl + 'images/location_images/',
  AUTH_TOKEN: "auth-token",
  NXP_ACCESS_TOKEN: "nxp-access-token",
};
